import FullLicensesDetails from "@/domain/entities/license/FullLicensesDetails";
import LicenseDetails from "@/domain/entities/license/LicenseDetails";
import FeatureFlag from "@/domain/enums/FeatureFlag";
import LicenseValidity from "@/domain/enums/LicenseValidity";
import {
    ActiveLicense as ActiveLicenseSDK,
    LicenseFeatureFlag as LicenseFeatureFlagSDK,
    UserLicensesDetails as UserLicensesDetailsSDK,
} from "@cs_teamwaydev/mailvista-sdk_react";

const mapLicenseFeatureFlag = (
    featureFlag: LicenseFeatureFlagSDK,
): FeatureFlag => {
    if (featureFlag === "MAIL_ENABLE_DEEPFOCUS") {
        return FeatureFlag.MAIL_ENABLE_DEEPFOCUS;
    }
    if (featureFlag === "DASHBOARD_DISPLAY_CO2") {
        return FeatureFlag.DASHBOARD_DISPLAY_CO2;
    }
    if (featureFlag === "ASSISTANT_ENABLE_VOCAL") {
        return FeatureFlag.ASSISTANT_ENABLE_VOCAL;
    }

    throw new Error(`Unsupported license feature flag: ${featureFlag}`);
};

const licenseDetailsToDomainMapper = (
    license: ActiveLicenseSDK,
): LicenseDetails =>
    new LicenseDetails({
        id: license.id,
        name: license.detail.name,
        validity: license.detail.validity as LicenseValidity,
        initialAnalysis: {
            byMail: license.detail.initialAnalysis.byMail,
            byDay: license.detail.initialAnalysis.byDay,
        },
        historyLimit: {
            byMail: license.detail.historyLimit.byMail,
            byMonth: license.detail.historyLimit.byMonth,
        },
        featureFlags: license.detail.featureFlags.map(mapLicenseFeatureFlag),
        isEnterprise: license.detail.isEnterprise,
        monthlyLimit: {
            byToken: license.detail.monthlyLimit.byToken,
            byAnalysedMails: license.detail.monthlyLimit.byAnalysedMails,
        },
    });

const fullLicensesDetailsToDomainMapper = (
    fullLicensesDetails: UserLicensesDetailsSDK,
): FullLicensesDetails =>
    new FullLicensesDetails({
        monthlyTokenCount: fullLicensesDetails.monthlyTokenCount,
        monthlySpentTokenCount: fullLicensesDetails.monthlySpentTokenCount,
        active:
            fullLicensesDetails.active?.map(licenseDetailsToDomainMapper) ?? [],
    });

export default fullLicensesDetailsToDomainMapper;
